import styled from "styled-components";

// UNUSED, remove!

export const List = styled.ul`
  list-style: none;
`;

export const ListItem = styled.li`
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

export const ListItem2 = styled.li`
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  margin-top: -8%;
`;

export const ListItem3 = styled.li`
  align-items: center;
  margin-top: -120%;
  font-size: 30px;
`;
